module.exports = __webpack_public_path__ + "static/Jan Szczepkowski w mundurze polskim-ece5671fcc58b057c72dfaa5b8164ed0.jpg";